/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useCallback, useContext, useState, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-unresolved
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useTranslator } from '@jutro/locale';
import { useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { MLTagManagerService } from 'ml-portals-services-react'
import '@xengage/gw-platform-translations';
import classNames from 'classnames';
import metadata from './MLPAScrollingTableHeaderComponent.metadata.json5';
import styles from './MLPAScrollingTableHeaderComponent.module.scss';
import messages from './MLPAScrollingTableHeaderComponent.messages';

import { IntlContext } from '@jutro/legacy/locale';

const ACTION_REMOVE_VEHICLE = 'remove';
const ACTION_EDIT_VEHICLE = 'edit';
const VEHICLE_STEP = '/vehicles';
const PREFILL_STEP = '/prefill';


function MLPAScrollingTableHeaderComponent(props) {
    const {
        model,
        isDisplayOnly,
        isAlaska7Day,
        termMonths,
        quoteStatus,
        hasNamedNonOwner,
        isPolicyChange,
        prevIndex,
        nextIndex,
        isPrevAvailable,
        isNextAvailable,
        coverablesToDisplay,
        updateMaps,
        onPrevButtonClick,
        onNextButtonClick,
        hasValidationErrors,
        navigateToStep,
        isModernProduct,
    } = props;

    const translator = useTranslator();
    const intl = useContext(IntlContext);
    const { refreshData } = useDataRefresh();

    const [displayedLineCoverages, setDisplayedLineCoverages] = useState(new Map());
    const covAmountDisplayed = useCallback((coverage, vehicle) => {
        if (displayedLineCoverages.has(coverage.code_ML)) {
            const vehId = displayedLineCoverages.get(coverage.code_ML);
            return vehId !== vehicle.publicID;
        }
    }, [displayedLineCoverages]);

    const formatAmountString = useCallback((amount) => {
        try {
            return intl.formatNumber(amount.amount, { style: 'currency', currency: amount.currency });
        } catch (e) {
            return '';
        }
    }, [intl]);
    
    const getTotalVehicleYearlyPremiumMessage = useCallback((coverage, vehicle) => {
        let totalLineCovPremium;
        let tempValue;
        let finalObj = vehicle.vehicleCost_ML;
        let totalVehYearlyPremium; 
        coverage.forEach((cov) => {
            if (cov.isLineCovCost_Ext === true) {
                tempValue = _.get(cov, 'lineCovCost_Ext.amount', 0);
                if (!covAmountDisplayed(cov, vehicle)) {
                    displayedLineCoverages.set(cov.code_ML, vehicle.publicID);
                    totalLineCovPremium = totalLineCovPremium === undefined ? 0 : totalLineCovPremium;
                    totalLineCovPremium += tempValue;
                    totalVehYearlyPremium = totalLineCovPremium + _.get(vehicle, 'totalPremium.amount', 0);
                    finalObj = {
                        amount: totalVehYearlyPremium,
                        currency: 'usd'
                    };
                } else {
                    finalObj = vehicle.vehicleCost_ML;
                }
            }
        });
        
        const amtString = formatAmountString(finalObj);
        const termMonthLabel = termMonths === 12 ? translator(messages.yr) : translator(messages.sixMonth);

        return `${amtString}/${termMonthLabel}`;
    }, [covAmountDisplayed, displayedLineCoverages, formatAmountString, termMonths, translator]);

    const getTotalVehicleMonthlyPremium = useCallback((coverage, vehicle) => {
        let totalLineCovPremium;
        let tempValue;
        let finalObj = vehicle.vehicleMonthlyCost_ML;
        let totalVehMonthlyPremium; 
        coverage.forEach((cov) => {
            if (cov.isLineCovCost_Ext === true) {
                tempValue = cov.lineLevelMonthlyCost_Ext.amount;
                if (!covAmountDisplayed(cov, vehicle)) {
                    displayedLineCoverages.set(cov.code_ML, vehicle.publicID);
                    totalLineCovPremium = totalLineCovPremium === undefined ? 0 : totalLineCovPremium;
                    totalLineCovPremium += tempValue;
                    totalVehMonthlyPremium = totalLineCovPremium + _.get(vehicle, 'monthlyPremium.amount', 0);
                    finalObj = {
                        amount: totalVehMonthlyPremium,
                        currency: 'usd'
                    };
                } else {
                    finalObj = vehicle.vehicleMonthlyCost_ML;
                }
            }
        });

        const amtString = formatAmountString(finalObj);
        return `${amtString}/${translator(messages.month)}`;
    }, [covAmountDisplayed, displayedLineCoverages, formatAmountString, translator]);

    const getAlaska7DayPremiumStr = useCallback((vehicle) => {
        const amtString = formatAmountString(vehicle.vehicleCost_ML);
        return `${amtString}/${translator(messages.sevenDays)}`;
    }, [formatAmountString, translator]);

    const getNonOwnerDisplayName = (vehicle) => {
        const rawName = _.get(vehicle, 'vehicleName')
        const displayName = rawName === 'Named Non-Owner' && isModernProduct ? 'Non Owner' : rawName;
        return displayName
    }

    const addPremiumsPerVehicle = useCallback(() => {
        _.get(model, 'vehicleCoverages', []).forEach((vehicleCov) => {
            vehicleCov.totalPremium = {
                amount: vehicleCov.vehicleCost_ML.amount,
                currency: vehicleCov.vehicleCost_ML.currency
            };

            vehicleCov.monthlyPremium = {
                amount: vehicleCov.vehicleCost_ML.amount / termMonths,
                currency: vehicleCov.vehicleCost_ML.currency
            };
        });
        refreshData();
    }, [model, refreshData, termMonths]);

    useEffect(() => {
        updateMaps();
        addPremiumsPerVehicle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [model]);

    const onRemoveVehicle = useCallback((evt) => {
        const vehicleIndex = evt.index;
        const data = {
            action: ACTION_REMOVE_VEHICLE,
            vehicleIndex
        };

        const stepName = PREFILL_STEP;
        navigateToStep(stepName, data);
    }, [navigateToStep]);

    const onEditVehicle = useCallback((evt) => {
        MLTagManagerService.sendEvent('linkClick', { linkName: 'PolicyChange_editVehicle' });
        const vehicle = coverablesToDisplay[evt.index];
        const data = {
            action: ACTION_EDIT_VEHICLE,
            model: vehicle
        };
        const stepName = VEHICLE_STEP;
        navigateToStep(stepName, data);
    }, [coverablesToDisplay, navigateToStep]);


    const generateVehicleOverrides = useCallback(() => {
        const vehicleOverrides = coverablesToDisplay.map((vehicle, index) => {
            return {
                [`prevIndexSpan${index}`]: {
                    content: prevIndex + (index + 1)
                },
                [`linkLineSpacing${index}`]: {
                    visible: !hasNamedNonOwner
                },
                [`spanRemoveVehicle${index}`]: {
                    visible: !hasNamedNonOwner
                },
                [`nonAlaska7dayPremium${index}`]: {
                    visible: !isAlaska7Day,
                    className: quoteStatus.isStale || hasValidationErrors(model) ? 'ml-scrolling-table__subheader-monthly-total strikethrough' : 'ml-scrolling-table__subheader-monthly-total',
                    content: getTotalVehicleMonthlyPremium(_.get(model, 'lineCoverages.value', _.get(model, 'lineCoverages', [])), vehicle)
                },
                [`alaska7dayPremium${index}`]: {
                    visible: !!isAlaska7Day,
                    content: getAlaska7DayPremiumStr(vehicle)
                },
                [`nonAlaska7dayYearly${index}`]: {
                    visible: !isAlaska7Day,
                    className: quoteStatus.isStale || hasValidationErrors(model) ? 'ml-scrolling-table__subheader-yearly-total strikethrough' : 'ml-scrolling-table__subheader-yearly-total',
                    content: getTotalVehicleYearlyPremiumMessage(_.get(model, 'lineCoverages.value', _.get(model, 'lineCoverages', [])), vehicle)
                },
                [`actionContainer${index}`]: {
                    visible: !isDisplayOnly && !isPolicyChange
                },
                [`vehicleNameSpan${index}`]: {
                    content: getNonOwnerDisplayName(vehicle)
                }
            };
        });

        return Object.assign({}, ...vehicleOverrides);
    }, [coverablesToDisplay, getAlaska7DayPremiumStr, getTotalVehicleMonthlyPremium, getTotalVehicleYearlyPremiumMessage, getNonOwnerDisplayName, hasNamedNonOwner, hasValidationErrors, isAlaska7Day, isDisplayOnly, isPolicyChange, model, prevIndex, quoteStatus.isStale]);

    const overrides = {
        scrollingTableHeader: {
            className: classNames('ml-scrolling-table__header', !isDisplayOnly ? styles.editing : '')
        },
        prevButton: {
            disabled: !isPrevAvailable,
            className: classNames('ml-scrolling-table__header_scroller-control prev prevButton', !isPrevAvailable ? ' inactive': '') 
        },
        nextButton: {
            disabled: !isNextAvailable,
            className: classNames('ml-scrolling-table__header_scroller-control next nextButton', !isNextAvailable ? ' inactive': '') 
        },
        vehicleIterableTopHeader: {
            data: coverablesToDisplay
        },
        vehicleIterableSubHeader: {
            data: coverablesToDisplay
        },
        ...generateVehicleOverrides()
    };

    const resolvers = {
        resolveComponentMap: {
        },
        resolveCallbackMap: {
            onPrevButtonClick,
            onNextButtonClick,
            onRemoveVehicle,
            onEditVehicle
        },
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

MLPAScrollingTableHeaderComponent.propTypes = {
    model: PropTypes.shape({}),
    onCovChange: PropTypes.func,
    isDisplayOnly: PropTypes.bool,
    isAlaska7Day: PropTypes.bool,
    termMonths: PropTypes.number,
    quoteStatus: PropTypes.shape({}),
    hasNamedNonOwner: PropTypes.bool,
    isPolicyChange: PropTypes.bool,
    prevIndex: PropTypes.number,
    nextIndex: PropTypes.number,
    isPrevAvailable: PropTypes.bool,
    isNextAvailable: PropTypes.bool,
    coverablesToDisplay: PropTypes.arrayOf(PropTypes.shape({})),
    updateMaps: PropTypes.func,
    onPrevButtonClick: PropTypes.func,
    onNextButtonClick: PropTypes.func,
    hasValidationErrors: PropTypes.func,
    navigateToStep: PropTypes.func
};

MLPAScrollingTableHeaderComponent.defaultProps = {
    quoteStatus: {},
    hasValidationErrors: _.noop,
    termMonths: 12
};

export default MLPAScrollingTableHeaderComponent;
